<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gks668/tc-custom/9781667449784.jpg?1684225679315" alt="This image is the cover for the book O Conde e a Solteirona Jane"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">O Conde e a Solteirona Jane
      </h1>
      <p class="bookDescription body article font2">
        <p>Desprovida de beleza e de fortuna, a extremamente simples Srta. Jane Featherstone não conseguiu atrair nenhum pretendente durante as três temporadas em que foi apresentada a sociedade. Em vez de se tornar um fardo para seu irmão e sua detestável esposa, a Srta. Featherstone jurou aceitar o primeiro homem que a pedisse em casamento -- embora ela sempre tenha adorado um homem que está muito acima dos seus sonhos...<br/> Lord Slade deve se casar com uma herdeira para honrar A Promessa que fez a seu pai em seu leito de morte, e ele precisa da ajuda da Srta. Featherstone para cortejar sua bela prima, herdeira de uma grande fortuna. Após sua raiva inicial, a Srta. Featherstone concorda com seu esquema, dizendo a ele que está fazendo isso porque admira seu histórico Parlamentar de Legislação Humanitária e sua reverência pela verdade. Mas quanto mais ele está com as duas primas, mais atraído ele fica pela Srta. Featherstone. O que um homem de palavra deve fazer? Quebrar uma Promessa que fez a um pai amado ou seguir seu coração e ficar com a Srta. Featherstone?<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cheryl Bolen, Tânia Nezio
      </h2>
      
      <p class="authorDescription body article">Desde que seu primeiro livro (A Duke Deceived) foi publicado em 1998 com excelentes críticas, Cheryl Bolen escreveu mais de três dezenas de livros, a maioria romances históricos ambientados na Inglaterra. Vários de seus livros ganharam prêmios Best Historical, e fazem parte da lista de best-seller dos jornais The New York Times e do USA Today, além de ser uma Amazon All Star cujos livros foram traduzidos para mais de nove idiomas. Ela também escreve artigos sobre a Época da Regência na Inglaterra e já deu vários workshops sobre esta era por mais de vinte anos.<br/> Em vidas anteriores, ela foi jornalista e professora de inglês. É casada, há mais de 30 anos, com um professor universitário recentemente aposentado e eles são pais de dois filhos adultos, ambos brilhantes e bonitos! Todos os quatro Bolens (e sua nova nora) adoram viajar para a Inglaterra, e Cheryl adora futebol americano universitário e basquete e adora ler cartas e diários escritos por inglesas mortas há muito tempo.<br/> Confira os sites de Cheeyl Bolen:<br/> Inscreva-se no boletim informativo - http://littl.ink/newsletter<br/> Blog - http://blogl.ink/RegencyRamblings<br/> Website - http://www.CherylBolen.com<br/> Facebook - http://fbl.ink/Facebook<br/> Pinterest - http://littl.ink/Pinterest<br/> Grupo de leitores - https://www.facebook.com/groups/2586590498319473/<br/></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Babelcube Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?43ccc64d